import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3 rounded-xl border border-gray-100 p-4" }
const _hoisted_2 = { class: "flex items-center gap-2 min-w-0" }
const _hoisted_3 = {
  "data-testid": "doctor-invite-company",
  class: "text-base font-medium text-gray-900 capitalize truncate"
}
const _hoisted_4 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "Status da empresa", -1)
const _hoisted_6 = {
  key: 1,
  class: "text-base text-gray-900"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "Status do médico", -1)
const _hoisted_8 = {
  key: 1,
  class: "text-base text-gray-900"
}
const _hoisted_9 = {
  key: 0,
  class: "pt-4 border-t border-gray-100"
}
const _hoisted_10 = {
  key: 1,
  class: "pt-4 border-t border-gray-100"
}

import { computed, ref } from 'vue'
import { mdiOfficeBuildingOutline, mdiContentCopy, mdiCheck, mdiEmailSyncOutline } from '@mdi/js'
import { useToast } from 'vue-toastification'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import ConfirmActionModal from '@/components/designSystem/modals/confirm.delete.action.vue'
import type { DoctorDetailCompanyLink } from '@/Network/Types/Responses/CompanyResponses'
import { CompanyDoctorInviteStatusEnum } from '@/Network/Types/Requests/CompanyRequests'
import { useDoctorDetailStore } from '@/pinia-store/useDoctorDetailStore'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { getInviteStatusConfig } from '../../helpers/doctorStatus'
import { getInviteErrorMessage } from '../../helpers/inviteErrors'
import { useInviteLink } from '../../helpers/useInviteLink'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInviteRow',
  props: {
    link: {}
  },
  setup(__props: any) {

const props = __props;



const toast = useToast()
const detailStore = useDoctorDetailStore()
const permissionsStore = usePermissionsStore()

const companyStatus = computed(() => getInviteStatusConfig(props.link.invite?.companyStatus))
const doctorStatus = computed(() => getInviteStatusConfig(props.link.invite?.doctorStatus))

const { inviteUrl, isCopied, copy } = useInviteLink(() => props.link.invite?.hash)

// Somente DECLINED por ora; EXPIRED/CANCELLED dependem de suporte no backend.
const RESENDABLE_DOCTOR_STATUSES = new Set<string>([CompanyDoctorInviteStatusEnum.DECLINED])

const canResend = computed(() => {
  const status = props.link.invite?.doctorStatus
  if (!status || !RESENDABLE_DOCTOR_STATUSES.has(status)) return false
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.CompanyDoctorInviteCreating,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const isResending = ref(false)
const showResendConfirm = ref(false)

async function handleResend() {
  try {
    isResending.value = true
    await detailStore.resendInvite(props.link.company.id)
    showResendConfirm.value = false
    toast.success('Convite reenviado com sucesso.')
  } catch (error) {
    console.error('Erro ao reenviar convite:', error)
    // Guard de domínio (convite já ativo → mensagem curada): exibido direto,
    // pois como fallback de notifyError a mensagem curada nunca apareceria.
    toast.error(
      getInviteErrorMessage(error, 'Não foi possível reenviar o convite. Tente novamente.')
    )
  } finally {
    isResending.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "grey-darken-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(mdiOfficeBuildingOutline)), 1)
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.link.company.name.toLowerCase()), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          (companyStatus.value)
            ? (_openBlock(), _createBlock(LabelBadge, {
                key: 0,
                label: companyStatus.value.label,
                color: companyStatus.value.color,
                icon: null,
                size: "small",
                class: "mt-1"
              }, null, 8, ["label", "color"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, "—"))
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          (doctorStatus.value)
            ? (_openBlock(), _createBlock(LabelBadge, {
                key: 0,
                label: doctorStatus.value.label,
                color: doctorStatus.value.color,
                icon: null,
                size: "small",
                class: "mt-1"
              }, null, 8, ["label", "color"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, "—"))
        ])
      ]),
      (_unref(inviteUrl))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(OutlineButton, {
              "data-testid": "doctor-copy-invite-link-button",
              "prepend-icon": _unref(isCopied) ? _unref(mdiCheck) : _unref(mdiContentCopy),
              width: "100%",
              height: "44px",
              class: "font-bold",
              onClick: _unref(copy)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(isCopied) ? 'Link copiado!' : 'Copiar link do convite'), 1)
              ]),
              _: 1
            }, 8, ["prepend-icon", "onClick"])
          ]))
        : _createCommentVNode("", true),
      (canResend.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(OutlineButton, {
              "data-testid": "doctor-resend-invite-button",
              "prepend-icon": _unref(mdiEmailSyncOutline),
              loading: isResending.value,
              width: "100%",
              height: "44px",
              class: "font-bold",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showResendConfirm.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Reenviar convite ")
              ]),
              _: 1
            }, 8, ["prepend-icon", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ConfirmActionModal, {
      show: showResendConfirm.value,
      title: "Reenviar convite",
      description: `Deseja reenviar o convite para ${_ctx.link.company.name}? Um novo convite pendente será criado.`,
      "text-button": "Reenviar",
      "is-loading": isResending.value,
      onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (showResendConfirm.value = false)),
      onHandleConfirm: handleResend
    }, null, 8, ["show", "description", "is-loading"])
  ], 64))
}
}

})